import styled from "styled-components";
import { ElementValue as TeamElementValue } from "./PitchElementData";
import { ElementValue as StatusElementValue } from "./status/StatusPitchElementData";

const ElementValueBar = styled.div<{
  variant: "default" | "live" | "finished";
}>`
  /* Target both ElementValue components */
  ${TeamElementValue}, ${StatusElementValue} {
    background-color: ${({ theme, variant }) => {
      if (variant === "live") return theme.colors.green;
      if (variant === "finished") return theme.colors.cyan;
      return theme.colors.greyLight4; // Light grey for pre-game
    }};

    color: ${({ theme }) => theme.colors.black};

    font-weight: ${({ variant }) => {
      if (variant === "finished") return "600";
      return "400"; // 400 for both pre-game and live
    }};

    border: ${({ theme }) => theme.borders[5]};
    border-top: 0;
  }
`;

export default ElementValueBar;
